<audio #player [src]="source" preload="metadata" poster="null"></audio>
<div class="player-controls-container">
  <button class="play-button" (click)="togglePlay()">
    <tpm-icon *ngIf="!isPlay(); else paused" icon="gpi-filled-play"></tpm-icon>
    <ng-template #paused>
      <tpm-icon icon="gpi-filled-pause"></tpm-icon>
    </ng-template>
  </button>
  <div class="progress-timer">{{ progressTime() }}</div>
  <button class="volume-button" (click)="toggleVolume()">
    <tpm-icon *ngIf="!isMuted(); else muted" icon="gpi-filled-volume"></tpm-icon>
    <ng-template #muted>
      <tpm-icon icon="gpi-filled-mute"></tpm-icon>
    </ng-template>
  </button>
  <mat-slider class="slider" disableRipple step="1" min="0" [max]="durationTime()">
    <input matSliderThumb [value]="currentTime()" (valueChange)="onSliderValueChange($event)" />
  </mat-slider>
</div>
